import { buttonVariants } from '@/components/ui/button';
import { ButtonLoadingContent, loadingButtonClass } from '@/components/buttons/ButtonLoadingContent';
import { cn } from '@/lib/utils';
import type { VariantProps } from 'class-variance-authority';
import { Button } from '@/components/ui/button';

interface ButtonProps {
    isLoading?: boolean;
    btnText: string;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    onClick?: any;
    disabled?: boolean;
    id?: string;
    icon?: any;
}

type Variant = VariantProps<typeof buttonVariants>['variant'];
type Size = VariantProps<typeof buttonVariants>['size'];

function resolveProps(cls: string): { variant: Variant; size: Size; extra: string } {
    let variant: Variant = 'default';
    let size: Size = 'default';

    if (cls.includes('btn-danger')) variant = 'destructive';
    else if (cls.includes('btn-outline-primary')) variant = 'outline';
    else if (cls.includes('btn-light')) variant = 'light';
    else if (cls.includes('btn-yellow')) variant = 'warning';

    if (cls.includes('btn-lg')) size = 'lg';
    else if (cls.includes('btn-sm')) size = 'sm';

    const extra = cls.includes('btn-block') ? 'w-full' : '';

    return { variant, size, extra };
}

function AppButton({
    isLoading,
    btnText,
    className = '',
    type = 'button',
    onClick,
    disabled,
    id,
    icon,
}: ButtonProps) {
    const { variant, size, extra } = resolveProps(className);

    return (
        <Button
            id={id}
            variant={variant}
            size={size}
            className={loadingButtonClass(isLoading, cn(extra, className))}
            type={type}
            onClick={onClick ? () => onClick() : undefined}
            disabled={disabled || isLoading}
            aria-busy={isLoading || undefined}
        >
            <ButtonLoadingContent loading={isLoading} loaderId={`${id}-loader`}>
                <>
                    {icon}
                    {btnText}
                </>
            </ButtonLoadingContent>
        </Button>
    );
};

export default AppButton;
